import { useCallback } from 'react';

import { useAnalyticsContext } from './context';

export type BankStatementDownloadModule = 'statements' | 'financial_closing';

export type BankStatementDownloadSource =
  | 'statements_downloads_hub'
  | 'statements_my_extracts'
  | 'statements_downloads_history'
  | 'financial_closing_general_card'
  | 'financial_closing_bank_card'
  | 'financial_closing_institution_drawer'
  | 'financial_closing_downloads_card'
  | 'financial_closing_downloads_drawer';

export type BankStatementDownloadScope = 'single' | 'batch';

export type BankStatementDownloadLevel =
  | 'file'
  | 'account'
  | 'institution'
  | 'category'
  | 'owner'
  | 'execution'
  | 'multi-execution'
  | 'all-filtered'
  | 'all';

export type BankStatementDownloadDeliveryMode = 'sync' | 'async';

export type BankStatementDownloadLifecycle = 'initiated' | 'retrieved';

export type BankStatementDownloadParams = {
  module: BankStatementDownloadModule;
  source: BankStatementDownloadSource;
  scope: BankStatementDownloadScope;
  level: BankStatementDownloadLevel;
  deliveryMode: BankStatementDownloadDeliveryMode;
  lifecycle?: BankStatementDownloadLifecycle;
  category?: string | null;
  grouping?: string | null;
  itemCount?: number | null;
};

export const BANK_STATEMENT_DOWNLOAD_EVENT = 'bank_statement_downloaded';

export const useBankStatementDownloadTracking = () => {
  const analytics = useAnalyticsContext();

  return useCallback((params: BankStatementDownloadParams) => {
    try {
      analytics?.mixPanel?.trackContinueEvent?.({
        customEvent: BANK_STATEMENT_DOWNLOAD_EVENT,
        lifecycle: 'initiated',
        ...params,
      });
    } catch {
      // Tracking must never break a download.
    }
  }, [analytics]);
};
